<template>
  <div>
    <v-alert text type="info">
      <p class="mb-0 black--text">
        Lakukan pengecekan ulang. Proses diskualifikasi, akan menjadikan peringkat bergeser. Jika sudah sesuai semuanya,
        lakukan klik Simpan untuk finalisasi data dan melanjutkan ke tahap selanjutnya.
      </p>
    </v-alert>
    <v-card flat class="mb-5">
      <v-card-text class="black--text pa-4">
        <v-row no-gutters>
          <template v-for="(jenjang, k_jenjang) in jenjangs">
            <v-col :key="k_jenjang" cols="12" md="4" sm="12">
              <v-card
                outlined
                :dark="kJenjang === k_jenjang"
                :color="kJenjang === k_jenjang ? 'green lighten-4' : ''"
                class="ma-1"
                style="border-radius: 5pt; border: 1px solid #66BB6A"
              >
                <v-list-item @click="onSelectJenjang(k_jenjang)">
                  <v-list-item-content class="green--text text-center">
                    <h3>Jenjang {{ jenjang.singkat }}</h3>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mb-5">
      <v-card-text class="black--text pa-2 px-5">
        <v-row class="mb-4">
          <v-col cols="12" md="4" class="py-4">
            <v-list-item class="px-0">
              <v-list-item-avatar color="secondary">
                <v-icon dark>mdi-google-classroom</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <div><span class="caption grey--text">Jenjang</span></div>
                <span class="info--text mb-0" style="font-size: 17px">
                  {{ $getDeepObj(jenjangs, `${kJenjang}.singkat`) }} ({{
                    $getDeepObj(jenjangs, `${kJenjang}.keterangan`)
                  }})
                </span>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="8" class="py-5">
            <v-row>
              <v-col cols="12" md="6">
                <div><span class="caption grey--text">Nama Daerah</span></div>
                <span class="mb-0">
                  {{ $getDeepObj(pspPeringkat, 'instansi.nama') }}
                </span>
              </v-col>
              <v-col cols="12" md="6">
                <div><span class="caption grey--text">Kepala Sekolah yang diterima</span></div>
                <v-chip color="pink" text-color="white">
                  <strong>Negeri</strong> : {{ $getDeepObj(jenjangs, `${kJenjang}.jml_terima_negeri`) || 0 }}
                </v-chip>
                <v-chip color="orange darken-3" text-color="white" class="ml-1">
                  <strong>Swasta</strong> : {{ $getDeepObj(jenjangs, `${kJenjang}.jml_terima_swasta`) || 0 }}
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <list-kasek
          v-if="$getDeepObj(jenjangs, `${kJenjang}.id`) && kJenjang"
          ref="kasek"
          :detail="
            Object.assign({}, pspPeringkatJenjang, {
              psp_peringkat_jenjang_id: this.$getDeepObj(jenjangs, `${kJenjang}.id`),
            })
          "
          :additional-params="{ k_jenjang: kJenjang }"
          :options="{ btnDownload: true }"
          type="lolos"
          @download="onDownload"
          @gugur="onDiskualifikasi"
          @batalgugur="onBatalDiskualifikasi"
        />
      </v-card-text>
    </v-card>
    <popup-diskualifikasi ref="diskualifikasi" :kandidat="kandidat" @save="onDiskualifikasiSave" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ListKasek from '../../base/ListKasek';
import PopupDiskualifikasi from '../popup/Diskualifikasi';
export default {
  components: { ListKasek, PopupDiskualifikasi },
  data() {
    return {
      kJenjang: null,
      kandidat: {},
    };
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
      validasi: (state) => state.validasi || [],
    }),

    pspPeringkatJenjang() {
      const jenjangs = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_jenjangs) || [];
      const jenjang = jenjangs.filter((jenjang) => +jenjang.k_jenjang === +this.kJenjang) || [];

      return jenjang[0] || {};
    },

    jenjangs() {
      let result = {};

      for (const jenjang of this.pspPeringkat.psp_peringkat_jenjangs) {
        result[jenjang.k_jenjang] = {
          id: this.$getDeepObj(jenjang, 'psp_peringkat_jenjang_id') || '',
          singkat: this.$getDeepObj(jenjang, 'm_jenjang.singkat') || '',
          keterangan: this.$getDeepObj(jenjang, 'm_jenjang.keterangan') || '',
          jml_terima_negeri: this.$getDeepObj(jenjang, 'jml_terima_negeri') || '',
          jml_terima_swasta: this.$getDeepObj(jenjang, 'jml_terima_swasta') || '',
        };
      }

      return result;
    },
  },

  methods: {
    ...mapActions('peringkat', ['download', 'save']),

    reset() {
      const jenjangs = Object.keys(this.jenjangs) || [];
      this.kJenjang = jenjangs[0] || '';

      if (this.type === 'lolos' && this.mode === 'form' && this.validasi.length) {
        const list = this.validasi
          .map((valid) => {
            return `<li>${valid}</li>`;
          })
          .join('');
        const message = `<p class="black--text text-justify mb-1">Mohon maaf, sistem mendeteksi ketidaksesuaian syarat DAPODIK kandidat dengan hasil <i>cut off</i> verval data pada fase Berita Acara saat ini, sebagai berikut:</p><ul style="padding-inline-start: 20px;" class="black--text">${list}</ul>`;
        this.$confirm(message, 'PERHATIAN', { confirmation: false, lblConfirmButton: 'Tutup', maxWidth: 700 });
      }
    },

    onDownload() {
      const id = this.$getDeepObj(this.jenjangs, `${this.kJenjang}.id`);
      const params = this.$refs.kasek.params || {};

      this.download({ action: 'seleksi', type: 'lolos-download', id, params }).then((url) => {
        window.open(url, '_blank');
      });
    },

    onSelectJenjang(kJenjang) {
      this.kJenjang = kJenjang;
      this.$nextTick(() => {
        this.$refs.kasek.onReload();
      });
    },

    onDiskualifikasi(data) {
      this.kandidat = data;
      this.$refs.diskualifikasi.open();
    },

    onBatalDiskualifikasi(data) {
      const jenjangId = data.psp_peringkat_jenjang_id;
      const kandidatId = data.psp_peringkat_kandidat_id;
      const msg = [
        '<span class="body-2 black--text">Apakah Anda yakin ingin membatalkan diskualifikasi kandidat berikut?</span>',
        `<p class="black--text"><strong>Nama: </strong>${data.nama}<br /><strong>SIMPKB ID: </strong>${data.ptk_id_kasek}</p>`,
      ].join('');

      this.$confirm(msg, 'Konfirmasi Batal Diskualifikasi').then(() => {
        this.save({ action: 'seleksi', type: 'batal-gugur', id: `${jenjangId}/${kandidatId}` }).then(() => {
          this.$success('Berhasil dibatalkan');
          this.$refs.kasek.onReload();
        });
      });
    },

    onDiskualifikasiSave(values) {
      const action = 'seleksi';
      const type = 'gugur';
      const jenjangId = this.kandidat.psp_peringkat_jenjang_id;
      const kandidatId = this.kandidat.psp_peringkat_kandidat_id;
      const params = new FormData();
      let error = '';

      if (!values.file) {
        error = 'Berkas pendukung belum dilengkapi';
      }

      if (!values.catatan_verval) {
        error = 'Alasan diskulafikasi belum dipilih';
      }

      if (values.catatan_verval === 'Alasan lainnya' && !values.catatan_verval_lain) {
        error = 'Alasan diskualifikasi lainnya belum diisikan';
      }

      if (error) {
        this.$error(error);
        return;
      }

      params.append('file', values.file);
      if (values.catatan_verval_lain) {
        params.append('catatan_gugur', values.catatan_verval_lain);
      } else {
        params.append('catatan_gugur', values.catatan_verval);
      }

      this.save({ params, action, type, id: `${jenjangId}/${kandidatId}`, upload: true }).then(() => {
        this.$success('Kandidat berhasil didiskualifikasi');
        this.$refs.diskualifikasi.close();
        this.$refs.kasek.onReload();
      });
    },
  },
};
</script>
